import React from 'react';
import Proptypes from 'prop-types';
import Plot from "react-plotly.js";
import Plotly from 'plotly.js/dist/plotly';
import _ from 'lodash';
import SaxsHPLCPlotMenuPanel from './SaxsHPLCPlotMenuPanel';
import SaxsSimplePlotter from './SaxsSimplePlotter';
import { getNSDURLbyModelListId, getDownloadHDF5FramesURL } from '../../api/ispyb';
import { Grid, Row, Col, Form, FormControl, FormGroup, Glyphicon, ControlLabel, Button, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';

class SaxsHPLCSummaryPlot extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isPlottedDataScaledToOne: false,
            isShowingI0Data: true,
            isShowingSum_IData: false,
            isShowingRgData: true,
            isShowingMassData: false,
            minFrameRange: null,
            maxFrameRange: null,
        }

        this.normalizeDataSerie = this.normalizeDataSerie.bind(this);
        this.divideValuesByMax = this.divideValuesByMax.bind(this);
        this.getMinAndMaxValues = this.getMinAndMaxValues.bind(this);
        this.onScaleButtonClicked = this.onScaleButtonClicked.bind(this);
        this.onI0ButtonClicked = this.onI0ButtonClicked.bind(this);
        this.onSum_IButtonClicked = this.onSum_IButtonClicked.bind(this);
        this.onRgButtonClicked = this.onRgButtonClicked.bind(this);
        this.onMassButtonClicked = this.onMassButtonClicked.bind(this);
        this.onPlotPointClicked = this.onPlotPointClicked.bind(this);
        this.onFrameRangeButtonClicked = this.onFrameRangeButtonClicked.bind(this);
        this.setFrameRange = this.setFrameRange.bind(this);
    }

    render() {
        let dataSeries = _.cloneDeep(this.props.dataSeries);

        if (dataSeries && dataSeries instanceof Array && dataSeries.length > 0) {
            if (this.state.isPlottedDataScaledToOne === true) {

                dataSeries.forEach(dataSerie => {
                    if (!dataSerie.values.isAStdDevDataSerie) {
                        let stdDevDataSerie = _.find(dataSeries, dataSerie2 => dataSerie2.name === dataSerie.name + 'StdDev')
                        this.normalizeDataSerie(dataSerie, stdDevDataSerie);
                    }
                });

            };

            // create dataSeries displayed on the plot as filtered by the user
            let requiredForDisplayDataSeries = [];
            dataSeries.forEach(dataSerie => {
                if ((dataSerie.values.name === 'I0' && this.state.isShowingI0Data) ||
                    (dataSerie.name === 'I0StdDev' && this.state.isShowingI0Data) ||
                    (dataSerie.name === 'sum_I' && this.state.isShowingSum_IData) ||
                    (dataSerie.name === 'sum_IStdDev' && this.state.isShowingSum_IData) ||
                    (dataSerie.name === 'Rg' && this.state.isShowingRgData) ||
                    (dataSerie.name === 'RgStdDev' && this.state.isShowingRgData) ||
                    (dataSerie.name === 'Mass' && this.state.isShowingMassData) ||
                    (dataSerie.name === 'MassStdDev' && this.state.isShowingMassData)
                ) {
                    requiredForDisplayDataSeries.push(dataSerie);
                }
            });

            return <div>
                <SaxsHPLCPlotMenuPanel buttons={[
                    {
                        label: 'I0',
                        onClick: this.onI0ButtonClicked,
                        color: _.find(dataSeries, item => item.label === 'I0') ? _.find(dataSeries, item => item.label === 'I0').color : '#000000',
                        isButtonPressed: this.state.isShowingI0Data
                    },
                    {
                        label: 'Sum_I',
                        onClick: this.onSum_IButtonClicked,
                        color: _.find(dataSeries, item => item.label === 'sum_I') ? _.find(dataSeries, item => item.label === 'sum_I').color : '#000000',
                        isButtonPressed: this.state.isShowingSum_IData
                    },
                    {
                        label: 'Rg',
                        onClick: this.onRgButtonClicked,
                        color: _.find(dataSeries, item => item.label === 'Rg') ? _.find(dataSeries, item => item.label === 'Rg').color : '#000000',
                        isButtonPressed: this.state.isShowingRgData
                    },
                    {
                        label: 'Mass',
                        onClick: this.onMassButtonClicked,
                        color: _.find(dataSeries, item => item.label === 'Mass') ? _.find(dataSeries, item => item.label === 'Mass').color : '#000000',
                        isButtonPressed: this.state.isShowingMassData
                    },
                    {
                        label: 'Scale',
                        onClick: this.onScaleButtonClicked,
                        color: null,
                        isButtonPressed: this.state.isPlottedDataScaledToOne
                    }
                ]} />

                <SaxsSimplePlotter
                    dataSeries={requiredForDisplayDataSeries}
                    divId={this.props.divId}
                    onPlotPointClicked={this.onPlotPointClicked}
                />

                {/* The footer*/}
                <Grid fluid>
                    <Row>
                        <Col xs={12} sm={10}>
                            <Form inline>
                                <FormGroup bsSize="small" controlId='rangeSelector'>
                                    <InputGroup bsSize="small" style={{ display: 'inline-table', verticalAlign: 'middle' }}>
                                        <InputGroup.Addon style={{ width: 'auto' }}> X-axis scale</InputGroup.Addon>
                                        <FormControl
                                            type="number"
                                            placeholder="start"
                                            style={{ width: '80px' }}
                                            onChange={event => this.setFrameRange('min', event.target.value)}
                                            value={this.state.minFrameRange}
                                        />
                                    </InputGroup>
                                    <InputGroup bsSize="small" style={{ display: 'inline-table', verticalAlign: 'middle' }}>
                                        <FormControl
                                            type="number"
                                            placeholder="end"
                                            style={{ width: '80px' }}
                                            onChange={event => this.setFrameRange('max', event.target.value)}
                                            value={this.state.maxFrameRange}
                                        />
                                        <InputGroup.Button style={{ width: 'auto' }}> <Button onClick={this.onFrameRangeButtonClicked} disabled={this.state.minFrameRange === null || this.state.maxFrameRange === null}> Go </Button> </InputGroup.Button>
                                    </InputGroup>
                                    <InputGroup>
                                        <InputGroup.Button style={{ width: 'auto' }}>
                                            <OverlayTrigger placement="left" overlay={<Tooltip> Download data for all displayed frames</Tooltip>}>
                                                <Button
                                                    bsSize="small"
                                                    href={getDownloadHDF5FramesURL(this.props.token, this.props.proposal, this.props.experimentId, this.state.minFrameRange, this.state.maxFrameRange)}
                                                    disabled={this.state.minFrameRange === null || this.state.maxFrameRange === null}
                                                > <Glyphicon glyph='download' /> </Button>
                                            </OverlayTrigger>
                                        </InputGroup.Button>
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </Grid>
            </div>
        } else {
            return null;
        }
    }

    setFrameRange(minOrMax, value) {
        if (minOrMax && value) {
            if (minOrMax === 'min') {
                this.setState({ minFrameRange: Number(value) })
            }
            if (minOrMax === 'max') {
                this.setState({ maxFrameRange: Number(value) })
            }
        }
    }

    onFrameRangeButtonClicked() {
        Plotly.relayout(this.props.divId, { 'xaxis.range': [this.state.minFrameRange, this.state.maxFrameRange] })
    }

    onScaleButtonClicked() {
        this.setState({ isPlottedDataScaledToOne: !this.state.isPlottedDataScaledToOne })
    }

    onI0ButtonClicked() {
        this.setState({ isShowingI0Data: !this.state.isShowingI0Data });
    }

    onSum_IButtonClicked() {
        this.setState({ isShowingSum_IData: !this.state.isShowingSum_IData });
    }

    onRgButtonClicked() {
        this.setState({ isShowingRgData: !this.state.isShowingRgData });
    }

    onMassButtonClicked() {
        this.setState({ isShowingMassData: !this.state.isShowingMassData })
    }

    onPlotPointClicked(event) {
        console.log(' You clicked on point x=' + event.points[0].x);
        this.props.onPlotPointClicked(event.points[0].x);
    }

    /** 
     * Normalize a dataSerie to 1. Looks for the maximum value and then divide everything but that value
     * @param {DataSerie} dataSerie a serie of data. 
     * @param {DataSerie} dataSerieStdDev corresponding serie of data which represent the standard deviation.
     */
    normalizeDataSerie = function (dataSerie, dataSerieStdDev) {
        let minMaxDataSerie = this.getMinAndMaxValues(dataSerie);
        let minMaxDataserieStdDev = this.getMinAndMaxValues(dataSerieStdDev);

        let max = Math.max(minMaxDataSerie.max, minMaxDataserieStdDev ? minMaxDataserieStdDev.max : 0)
        this.divideValuesByMax(dataSerie, max);
        this.divideValuesByMax(dataSerieStdDev, max);

        // this.ranges[multiPlotsData[i].label] = values;

        // return dataSerie;
    };

    /** Given a stat float[] and a max number it will divide each value by max **/
    divideValuesByMax = function (dataSerie, max) {
        if (dataSerie) {
            for (let j = 0; j < dataSerie.values.y.length; j++) {
                if (max != 0) {
                    dataSerie.values.y[j] = Number(dataSerie.values.y[j]) / max;
                }
            }
        }
    };

    /** returns min and max value of a data serie 
     * @param {DataSerie} dataSerie data serie object for one measurement
     * @param {DataSerie} dataSerie corresponding data serie errors associated the the measurement
     * 
     */
    getMinAndMaxValues = function (dataSerie) {
        if (dataSerie) {
            let max = 0;
            let min = dataSerie.values.y[0];
            for (let j = 0; j < dataSerie.values.y.length; j++) {
                if (Number(dataSerie.values.y[j]) > max) {
                    max = Number(dataSerie.values.y[j]);
                }
                if (Number(dataSerie.values.y[j]) < min) {
                    min = Number(dataSerie.values.y[j]);
                }
            }
            return {
                max: Number(max),
                min: Number(min)
            };
        }
    };
}

export default SaxsHPLCSummaryPlot;

SaxsHPLCSummaryPlot.proptypes = {
    /* div identifier containing the plot */
    divId: Proptypes.string,
    /* the data to be displayed */
    graph: Proptypes.object,
}



// WEBPACK FOOTER //
// ./src/components/saxs/SaxsHPLCSummaryPlot.js